import * as _helperCompilationTargets3 from "@babel/helper-compilation-targets";
var _helperCompilationTargets2 = "default" in _helperCompilationTargets3 ? _helperCompilationTargets3.default : _helperCompilationTargets3;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.resolveBrowserslistConfigFile = resolveBrowserslistConfigFile;
  exports.resolveTargets = resolveTargets;
  function _helperCompilationTargets() {
    const data = _helperCompilationTargets2;
    _helperCompilationTargets = function () {
      return data;
    };
    return data;
  }
  function resolveBrowserslistConfigFile(browserslistConfigFile, configFilePath) {
    return undefined;
  }
  function resolveTargets(options, root) {
    const optTargets = options.targets;
    let targets;
    if (typeof optTargets === "string" || Array.isArray(optTargets)) {
      targets = {
        browsers: optTargets
      };
    } else if (optTargets) {
      if ("esmodules" in optTargets) {
        targets = Object.assign({}, optTargets, {
          esmodules: "intersect"
        });
      } else {
        targets = optTargets;
      }
    }
    return (0, _helperCompilationTargets().default)(targets, {
      ignoreBrowserslistConfig: true,
      browserslistEnv: options.browserslistEnv
    });
  }
  0 && 0;

  //# sourceMappingURL=resolve-targets-browser.js.map
  return exports;
}